import { IDownloadInvoicePayload, IFetchInvoicesCollectionPayload } from "store/entities/invoices/interfaces";

import { BaseApi } from "../base";

export default class InvoiceApi extends BaseApi {
  protected readonly service = "rest-api";
  protected readonly prefix = "billing/invoices";

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchAll = (params: IFetchInvoicesCollectionPayload) => this.get("", { ...params });
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  downloadInvoice = (params: IDownloadInvoicePayload) => this.get(`${params.id}/PDF`);
}
